import { apiRequest } from "../index";

export const askSupportAsGuest = async ({  question }) => {
  return apiRequest(`/api/common/ai/ask-support-as-guest`, "POST", {
   question 
  });
};

export const askSupportAsLoggedInUser = async ({  question }) => {
 
  return apiRequest(`/api/common/ai/ask-support`, "POST", {
   question 
  });
}; 

export const getMessages = async () => {
  return apiRequest(`/api/common/ai/messages`, "GET");
};